// extracted by mini-css-extract-plugin
export var smallSpinner = "_qj-0";